var isCancel = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

export { isCancel as default };
//# sourceMappingURL=isCancel.js.map
